// extracted by mini-css-extract-plugin
export default {"form_button_back":"form-button-back_form_button_back__+o974"};